import React from "react";
import { useLanguage } from "../../LanguageProvider";

export const Header = ({ title, subtitle, sessionParticipantsCount, totalExpenses, paidCount }) => {
  const { t } = useLanguage();
  
  const paidPercentage = sessionParticipantsCount > 0 
    ? (paidCount / sessionParticipantsCount) * 100 
    : 0;

  return (
    <header className="top-header">
      <div className="header-main-area">
        <div className="header-title">
          <h1>{title}</h1>
          {subtitle && <span className="header-subtitle">{subtitle}</span>}
        </div>
        
        {sessionParticipantsCount > 0 && totalExpenses > 0 && (
          <div className="header-stats-premium">
            <div className="stat-unit">
              <span className="stat-label">{t("total")}</span>
              <span className="stat-value highlight">{totalExpenses.toFixed(2)} kr</span>
            </div>
            <div className="stat-separator" />
            <div className="stat-unit">
              <span className="stat-label">{t("paid")}</span>
              <span className="stat-value">{paidCount}/{sessionParticipantsCount}</span>
            </div>
          </div>
        )}
      </div>

      {sessionParticipantsCount > 0 && (
        <div className="header-progress-track">
          <div 
            className={`header-progress-fill ${paidPercentage === 100 ? 'complete' : ''}`}
            style={{ width: `${paidPercentage}%` }}
          />
        </div>
      )}
    </header>
  );
};
